import { Block } from '../models/block';
import { ApiSuccessResponse, IApiService, IPaginatedResponse } from '../services/api_service';

export const block = (centralApi: IApiService) => ({
  index: (params = {}): Promise<IPaginatedResponse<Block>> => {
    return centralApi.get('/block/by-account', { params })
      .then((res) => {
        let normalizedData = res;
        if (res.data === undefined) {
          normalizedData = res;
          normalizedData.data = (res as any).blocks;
        }
        return normalizedData;
      });
  },
  post: (data): Promise<ApiSuccessResponse<void>> => {
    return centralApi.post('/block', data);
  },
  put: (data): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put('/block', data);
  },
  delete: (ani, params): Promise<ApiSuccessResponse<void>> => {
    return centralApi.delete(`/block/${ani}`, { params });
  }
});
